import { render, staticRenderFns } from "./CustomerSection.vue?vue&type=template&id=ca7ee296&scoped=true"
import script from "./CustomerSection.vue?vue&type=script&lang=js"
export * from "./CustomerSection.vue?vue&type=script&lang=js"
import style0 from "./CustomerSection.vue?vue&type=style&index=0&id=ca7ee296&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca7ee296",
  null
  
)

export default component.exports